<template>
  <button v-if="publicToken !== null && getContactForm === true" class="rp-buy-button rp-button"
      v-on:click="submitContactForm"
      v-bind:class="{ 'is-loading': isClick }"
      v-bind:style="{
      backgroundColor: color.secondaryMain,
      color: color.secondarySub,
      borderColor: color.secondaryMain,
      fontFamily: globalFont
      }">

      <template
        v-if="contactForm.form.contact_button_icon !== '' &&
          contactForm.form.contact_button_icon !== null &&
          rpLink !== ''"
      >
        <span class="rp-icon">
          <i v-bind:class="'fa ' + contactForm.form.contact_button_icon"></i>
        </span>
      </template>

      <span v-if="contactForm.form.contact_button_id === '-1'" class="custom-text-overflow">
        {{ contactForm.form.contact_button_custom_text }}
      </span>
      <span v-else>
        <span v-if="locale == 'en'">
          {{ contactForm.form.contact_button_text_en }}
        </span>
        <span v-else-if="locale == 'vi'">
          {{ contactForm.form.contact_button_text_vi }}
        </span>
        <span v-else>
          {{ contactForm.form.contact_button_text_th }}
        </span>
      </span>
  </button>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'CartFormButton',
  props: {
    mode: {
      type: String,
      default: 'auto'
    },
    rpLabel: {
      type: String,
      default: 'Contact Submit'
    },
    rpLink: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      product: {
        quantity: 1
      },
      loading: {
        submitButton: false
      }
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          formSubmitThankyou: 'Thank you',
          formSubmitError: 'Error occured',
          submitButtonContact: 'Contact',
          submitButtonReserve: 'Reserve',
          submitButtonBuyNow: 'Buy now',
          labelFirstname: 'Firstname',
          labelLastname: 'Lastname',
          labelEmail: 'Email',
          labelTel: 'Tel.',
          alertPleaseSelectVariants: 'Please select a product variants',
          pleaseFillContactFormCompletely: 'Please fill the form completely',
          pleaseSelectQuantityMoreThenZero: 'Please select a product quantity more than 0'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          formSubmitThankyou: 'ได้รับข้อมูลเรียบร้อยแล้ว',
          formSubmitError: 'เกิดข้อผิดพลาด',
          submitButtonContact: 'ติดต่อ',
          submitButtonReserve: 'จอง',
          submitButtonBuyNow: 'สั่งซื้อ',
          labelFirstname: 'ชื่อ',
          labelLastname: 'นามสกุล',
          labelEmail: 'อีเมล',
          labelTel: 'เบอร์ติดต่อ',
          alertPleaseSelectVariants: 'กรุณาเลือกตัวเลือกย่อยของสินค้า',
          pleaseFillContactFormCompletely: 'กรุณากรอกข้อมูลให้ครบถ้วน',
          pleaseSelectQuantityMoreThenZero: 'กรุณาเลือกจำนวนของสินค้าให้มากกว่า 0'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          formSubmitThankyou: 'Cảm ơn',
          formSubmitError: 'Có lỗi xảy ra',
          submitButtonContact: 'Liên hệ',
          submitButtonReserve: 'Đặt trước',
          submitButtonBuyNow: 'Mua ngay',
          labelFirstname: 'Tên',
          labelLastname: 'Họ',
          labelEmail: 'Email',
          labelTel: 'Sđt',
          alertPleaseSelectVariants: 'Vui lòng chọn thuộc tính sản phẩm',
          pleaseFillContactFormCompletely: 'Vui lỏng nhập đầy đủ thông tin',
          pleaseSelectQuantityMoreThenZero: 'Vui lòng chọn số lượng sản phẩm lớn hơn 0'
        }
      }
    },
    publicToken () {
      return Cart.token.public
    },
    getContactForm () {
      Cart.getContactForm()
      return true
    },
    color () {
      return Cart.getColor()
    },
    globalFont () {
      return Cart.getGlobalFont()
    },
    contactForm () {
      return Cart.contactForm
    },
    isClick () {
      return Cart.submitContactForm.loading
    },
    locale () {
      return Cart.getLocale()
    }
  },
  methods: {
    submitContactForm () {
      if (this.rpLink != '') {
        if (this.rpLink == 'disable') {
          // Do Nothing...
        } else {
          document.location = this.rpLink
        }
      } else {
        Cart.$emit('ContactFormSubmit')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rp-buy-button {
  overflow: hidden;
}
.custom-text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/cartForm/CartFormButton.vue